export class Status {
    id: number;
    label: string; // active, inactive, etc.
    icon?: string;
    type?: StatusTypes;
    table?: string;
    order?: number;
    hasTooltip?: boolean;
    tooltipContent?: string;
}

// mainly used for UI representation of status
export enum StatusTypes {
    success = 'success',
    default = 'default',
    danger = 'danger',
    warning = 'warning',
    info = 'info'

}
